import script from "./PermissionError.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionError.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionError.vue?vue&type=style&index=0&id=86008f1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86008f1a"]])

export default __exports__